export default __webpack_public_path__ + "static/media/driving.5c0d2c2d.svg";